import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AlertComponent } from 'app/popup/alert.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { EqualvalidatorDirective } from 'app/validators/equalvalidator.directive';
import { environment } from 'environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-confirmpasswordchange',
  templateUrl: './confirmpasswordchange.component.html',
  styleUrls: ['./confirmpasswordchange.component.scss']
})
export class ConfirmpasswordchangeComponent implements OnInit {
  form;
  isPhonePortrait = false;
  params: any = {};
  loginUser: any = { };
  systemCode: String = null;
  public isLoading = false;
  message = null;
  resetcodepattern = /^[0-9]+$/;
  token : string;

  constructor(public authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,
    private responsive: BreakpointObserver,
     public utility: UtilityServiceService) { }

  ngOnInit() {
    this.responsive.observe([
			Breakpoints.HandsetLandscape,      
			Breakpoints.TabletLandscape,
			])
			.subscribe(result => {
	  
			 
				this.isPhonePortrait = false; 
	  
			  if (result.matches) {
				this.isPhonePortrait = true;
			  }
			});
    this.route.params.subscribe((params: Params) => {
      this.token = params['token'];
      if(!this.token.includes('==')){
        this.token = this.token + '==';
      }
    });
   
    this.systemCode = environment.authWebApi.systemCode
    this.initForm();

  }

  initForm(){
    this.form = new FormGroup({
        // EmailAddress: new FormControl(this.loginUser.EmailAddress, Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]))
         Password: new FormControl('', Validators.compose([Validators.required,Validators.pattern( '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$')] ))
      , ConfirmPassword: new FormControl( '', Validators.compose([Validators.required,Validators.pattern( '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$')] ))
       , ResetToken: new FormControl(this.token)

  });

  }

  onSubmit(obj:any){

    this.loginUser = obj;

    this.authWebService.passwordResetConfirm(this.loginUser);
  }
  getErrorEmail() {
    return this.form.get('EmailAddress').hasError('required') ? 'Email is required' :
           this.form.get('EmailAddress').hasError('pattern') ? 'Email Address is invalid . Please enter a valid email address eg:  name@example.com' : '';
  }
  getPasswordErr(){
    return this.form.get('Password').hasError('required') ? 'Password is required' :
           this.form.get('Password').hasError('pattern') ? 'Password must be atleast eight characters including one uppercase letter, one lowercase letter and one number' : '';
  }
  getConfirmPasswordErr(){
    return this.form.get('ConfirmPassword').hasError('required') ? 'Confirm Password is required' :
           this.form.get('ConfirmPassword').hasError('pattern') ? 'Confirm Password must be atleast eight characters including one uppercase letter, one lowercase letter and one number' :
           this.form.get('ConfirmPassword').hasError('notMatched') ? 'Password and Confirm Password do not match' :'';
  }
  passwordMatch(Password,confirmPassword){
    if(Password!=confirmPassword){
      this.form.controls['ConfirmPassword'].setErrors({'notMatched':true});  }
  }
  getResetCodeErr(){
    return this.form.get('ResetCode').hasError('required') ? 'Reset Code is required' :
           this.form.get('ResetCode').hasError('pattern') ? 'Reset Code must contain numbers only' : '';

  }


}
